var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    directives: [{
      name: "clickoutside",
      rawName: "v-clickoutside",
      value: (function () {
        _vm.focus = false
      }),
      expression: "()=>{focus=false}"
    }],
    staticClass: "btn",
    class: [("btn-" + (_vm.$parent.type)), _vm.active ? 'active' : '', _vm.focus ? 'focus' : ''],
    on: {
      "click": function($event) {
        _vm.focus = true
      }
    }
  }, [(_vm.$parent.multiply) ? [_c('input', {
    attrs: {
      "type": "checkbox",
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onChange1
    }
  }), _vm._v(" "), _vm._t("default")] : [_c('input', {
    attrs: {
      "type": "radio",
      "name": _vm.name,
      "autocomplete": "off"
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "change": _vm.onChange2
    }
  }), _vm._v(" "), _vm._t("default")]], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0288834c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/buttons/ButtonGroupItem.vue
// module id = 130
// module chunks = 19